<template>
  <div class="o-orderSummary">
    <OrderDetails ref="order" title="Order summary"/>
    <CartCoupon 
      class="o-orderSummary__couponCode"
      ref="CartCoupon" />
  </div>
</template>

<script>
import CartCoupon from './CartCoupon.vue'
import OrderDetails from './OrderDetails.vue'

export default {
  components: {
    CartCoupon,
    OrderDetails
  }
}
</script>



// WEBPACK FOOTER //
// OrderSummary.vue?1c43100a